import reducer from "./reducer";
export { default as ReasonForPointAwarding } from "./components/index";
export { default as reasonForPointAwardingReducerName } from "./constants";
export default reducer;
